import React, { CSSProperties } from 'react';
import { SystemIconButton, SystemIconButtonProps } from '../Icon/SystemIconButton';
import Dropdown, { DropdownProps } from '../Dropdown/Dropdown';
import { Uds } from '../../types';

export interface IconDropdownProps extends Uds<Omit<DropdownProps, 'ButtonItem' | 'fullWidth'>> {
  iconName?: SystemIconButtonProps['iconName'];
  iconSize?: SystemIconButtonProps['size'];
  iconClassName?: string;
  iconStyle?: CSSProperties;
  disabledMessage?: string;
}

export const IconDropdown: React.FC<React.PropsWithChildren<IconDropdownProps>> = ({
  iconName = 'more_vert',
  iconClassName,
  iconStyle,
  iconSize,
  disabledMessage,
  dataTest,
  ...rest
}) => (
  <Dropdown
    dataTest={dataTest}
    ButtonItem={(disabled) => (
      <SystemIconButton
        disabledToolTipText={disabledMessage}
        iconName={iconName}
        aria-label={rest.tooltip ?? 'icon'}
        dataTest={dataTest ? `${dataTest}-button` : 'icon-dropdown-button'}
        disabled={disabled}
        className={iconClassName}
        size={iconSize}
        style={{ ...iconStyle, ...(disabled ? { pointerEvents: 'none' } : undefined) }}
      />
    )}
    {...rest}
  />
);

export default IconDropdown;
